import * as axios from "axios";

import Api from "./Api";
import { Station } from "../types/Station";
import { AlertType } from "../types/AlertMessage";

export default class StationService extends Api {
  private _endpoint = "/Station";

  public async getAll(filter: string, geometry: any): Promise<Station[]> {
    return super
      .init()
      .post<Station[]>(`${this._endpoint}/search`, { filter, geometry })
      .then((response) => {
        return response.data;
      })
      .catch((error: axios.AxiosError) => {
        this.showAlert({
          message: (error.response?.data as string) ?? error.message,
          type: AlertType.Error,
        });
        return [];
      });
  }
}
